module.exports = __webpack_public_path__ + "static/month_2_pages-84239ea24c4ebcc867aa87a7bd440d08.png";